import React from 'react';
import Input from '../../../components/ui/Input';



const AccountSettingsTab = ({ formData, handleChange, handleSelectChange, handleCheckboxChange, errors, isEditing }) => {
  const dashboardLayoutOptions = [
    { value: 'compact', label: 'Compact View' },
    { value: 'detailed', label: 'Detailed View' },
    { value: 'grid', label: 'Grid Layout' },
  ];

  const notificationFrequencyOptions = [
    { value: 'instant', label: 'Instant' },
    { value: 'hourly', label: 'Hourly Digest' },
    { value: 'daily', label: 'Daily Digest' },
    { value: 'weekly', label: 'Weekly Digest' },
  ];

  const timezoneOptions = [
    { value: 'America/New_York', label: 'Eastern Time (ET)' },
    { value: 'America/Chicago', label: 'Central Time (CT)' },
    { value: 'America/Denver', label: 'Mountain Time (MT)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' },
    { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 mb-6">
        <p className="text-sm text-warning-foreground">
          <strong>Note:</strong> Password changes require email verification for security purposes.
        </p>
      </div>
      <div className="space-y-6">
        <Input
          label="Current Password"
          type="password"
          name="currentPassword"
          value={formData?.currentPassword}
          onChange={handleChange}
          placeholder="Enter current password"
          error={errors?.currentPassword}
          disabled={!isEditing}
          description="Required to change password or email"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="New Password"
            type="password"
            name="newPassword"
            value={formData?.newPassword}
            onChange={handleChange}
            placeholder="Enter new password"
            error={errors?.newPassword}
            disabled={!isEditing}
            description="Minimum 8 characters"
          />
          
          <Input
            label="Confirm New Password"
            type="password"
            name="confirmPassword"
            value={formData?.confirmPassword}
            onChange={handleChange}
            placeholder="Confirm new password"
            error={errors?.confirmPassword}
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsTab;